import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
class DpBillsPresenter {
    constructor(useCases, actions) {
        this.useCases = useCases;
        this.actions = actions;
    }
    getDpBillDetailsReport(req) {
        this.actions.dpBillReport.hideError("DpBillsDetailsReport");
        this.actions.dpBillReport.loader("DpBillsDetailsReport");
        this.useCases.dpBillReport.execute({
            onSuccess: (data) => {
                if (!!data && data.length < 1) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.DPBILL];
                    this.actions.dpBillReport.addMsg(emptyValidation.message, true, emptyValidation.icon, "DpBillsDetailsReport");
                    this.actions.dpBillReport.getDpBillDetailsReport(data, "DpBillsDetailsReport");
                }
                else {
                    this.actions.dpBillReport.clear("DpBillsDetailsReport");
                    this.actions.dpBillReport.getDpBillDetailsReport(data, "DpBillsDetailsReport");
                }
                this.actions.dpBillReport.stopLoader("DpBillsDetailsReport");
            },
            onError: (error) => {
                this.actions.dpBillReport.setError({ isOpen: true, error }, "DpBillsDetailsReport");
                this.actions.dpBillReport.stopLoader("DpBillsDetailsReport");
            },
        }, req);
    }
}
export default DpBillsPresenter;
